document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-product-description-toggle]');
  if (!toggle) return;

  const preview = toggle.closest('[data-product-description-preview]');
  const summary = preview?.querySelector('[data-product-description-summary]');
  const fullDescription = preview?.querySelector('[data-product-description-full]');
  if (!summary || !fullDescription) return;

  const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!isExpanded));
  toggle.textContent = isExpanded ? 'Read more' : 'Read less';
  summary.hidden = !isExpanded;
  fullDescription.hidden = isExpanded;
});
